import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { CookieService } from "../cookie/cookie.service";

@Injectable({
  providedIn: "root"
})
export class CrossDomainTrackingService {
  isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document,
    public route: ActivatedRoute,
    private cookieService: CookieService,
  ) {}

  getCookie(cookieName: string): string | null {
    return this.cookieService.getCookie(cookieName);
  }

  saveSSKey(domains: [string]) {
    if (this.isBrowser) {
      const ssKey = this.route.snapshot.queryParamMap.get("sskey");

      if (ssKey) {
        this.updateUrls(domains, ssKey, "sskey");
      }
    }
  }

  getTealiumKey() {
    if (this.isBrowser) {
      let splitTealCookie;
      let tealSpecificValue;
      let tealCookieValue: any = this.getCookie("TEAL");

      if (tealCookieValue) {
        tealCookieValue = tealCookieValue.split(":");

        splitTealCookie = tealCookieValue[1];

        splitTealCookie = splitTealCookie.split("$");

        tealSpecificValue = splitTealCookie[0];
      } else {
        tealSpecificValue = "No Tealium ID found";
      }
      return tealSpecificValue;
    }
  }

  saveTealiumKey(domains: [string]) {
    if (this.isBrowser) {
      const tealValue = this.getTealiumKey();

      if (tealValue !== "No Tealium ID found") {
        this.updateUrls(domains, tealValue, "tealid");
      }
    }
  }

  saveCubedKey(domains: [string]) {
    if (this.isBrowser) {
      const vscr_vid = this.getCookie("vscr_vid");
      const vscr_sid = this.getCookie("vscr_sid");
      const cubedString = `${vscr_vid}${vscr_sid}`;

      if (cubedString) {
        this.updateUrls(domains, cubedString, "ydat");
      }
    }
  }

  getMidKey() {
    let midValue!: string;

    if (this.isBrowser) {
      const visitor = this.getVisitor();

      if (visitor && visitor._fields) {
        midValue =
          "MCMID=" +
          visitor._fields.MCMID +
          "|MCORGID=B1391C8B533095AA0A490D4D@AdobeOrg|" +
          "TS=" +
          Date.now();
      } else {
        midValue = "No cookie found";
      }
    }

    return midValue;
  }

  getMidId() {
    if (this.isBrowser) {
      const visitor = this.getVisitor();

      if (visitor && visitor._fields) {
        return visitor._fields.MCMID;
      }
    }
  }

  getVisitor() {
    if (this.isBrowser) {
      return (window as any).Visitor?.getInstance(
        "B1391C8B533095AA0A490D4D@AdobeOrg",
        {
          trackingServer: "metrics.legalandgeneral.com",
          trackingServerSecure: "smetrics.legalandgeneral.com"
        }
      );
    }
  }

  saveMidKey(domains: [string]) {
    if (this.isBrowser) {
      const midValue = this.getMidKey();

      if (midValue) {
        this.updateUrls(domains, midValue, "adobe_mc");
      }
    }
  }

  setReferrerDomain() {
    if (this.isBrowser && this.document.referrer) {
      const referrerDomain = new URL(document.referrer);
      const currentDomain = new URL(document.documentURI);

      if (
        this.getReferrerDomain() === null &&
        referrerDomain.origin !== currentDomain.origin
      ) {
        sessionStorage.setItem("Referrer", referrerDomain.origin);
      }
    }
  }

  getReferrerDomain() {
    if (this.isBrowser) {
      return sessionStorage.getItem("Referrer");
    }

    return null;
  }

  getOriginUrl() {
    return this.document.documentURI;
  }

  updateUrls(domains: string[], key: string, urlParam: string) {
    const listOfAnchors = document.querySelectorAll("a");
    listOfAnchors.forEach((item) => {
      if (item.href && item.href !== "#") {
        const linkUrl = new URL(item.href);

        if (domains.includes(linkUrl.host.replace("www.", ""))) {
          const params = new URLSearchParams(linkUrl.search);
          params.append(urlParam, key);

          if (linkUrl.hash) {
            const hash = linkUrl.hash;
            linkUrl.hash = "";

            const prefix = linkUrl.search ? "&" : "?";

            linkUrl.search += prefix + params.toString();
            item.href = linkUrl.toString()
              .replace(linkUrl.search, hash + linkUrl.search)
              .replace(/(.*?)(\?)/g,
              (match, p1, p2, offset) => {
                return offset === 0 ? match : p1 + "&";
              });
          } else {
            linkUrl.search = params.toString();
            item.href = linkUrl.href;
          }
        }
      }
    });
  }
}
